/* eslint-disable no-unreachable */
import { USER_PERMISSIONS } from "actions/auth/authAction";
import { SIDEBAR_MENU } from "actions/auth/authAction";
import { SET_USER_INFO } from "actions/auth/authAction";

const initialState = {
  userInfo: {},
  adminRoutes: [],
  userPermissions: [],
};
export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        userInfo: action.payload,
      };
    case SIDEBAR_MENU:
      return {
        ...state,
        adminRoutes: action.payload,
      };
    case USER_PERMISSIONS:
      return {
        ...state,
        userPermissions: action.payload,
      };
    default:
      return state;
  }
}
